module.exports = __webpack_public_path__ + "static/media/login_bg.787b8042.jpg";